<div class="L-tableUI__tableWrapper" [ngClass]="tableWrapperClass">
  <div
    *ngIf="!dataSource?.data"
    class="h-[55vh] flex justify-center items-center"
  >
    <ng-container *ngIf="primaryMessage; else defaultMessage">
      <p class="font-bold" i18n="@@apply_filters_and_click_fetch_records">
        Apply filters and click fetch records
      </p>
    </ng-container>
    <ng-template #defaultMessage>
      <p class="font-bold" i18n="@@fetch_list_of_records">
        Fetch list of records
      </p>
    </ng-template>
  </div>

  <div
    *ngIf="dataSource?.data && !dataSource.data.length"
    class="h-[55vh] flex justify-center items-center"
  >
    <p class="font-bold" i18n="@@no_records_found">No Records Found</p>
  </div>

  <table
    #table
    id="grid"
    *ngIf="dataSource?.data?.length"
    mat-table
    [dataSource]="dataSource"
    (matSortChange)="announceSortChange($event)"
    class="L-tableUI__table"
    matSort
    [matSortActive]="matSortActive"
    [matSortDirection]="matSortDirection"
  >
    <ng-container
      *ngFor="let column of initColumns; trackBy: customTrackBy"
      [matColumnDef]="column.key"
      [sticky]="column.value === 'checkbox'"
    >
      <!-- kindly check styles for checkbox styling -->
      <ng-container *hasPermissions="column.perms">
        <ng-container *ngIf="column.type === 'checkbox'">
          <th
            class="bg-background text-lg uppercase"
            mat-header-cell
            *matHeaderCellDef
          >
            <mat-checkbox
              (change)="onCheckAll($event)"
              [checked]="masterCheckboxChecked"
              *ngIf="showCheckboxes"
            ></mat-checkbox>
          </th>
          <td mat-cell class="text-sm text-center" *matCellDef="let item">
            <!-- <mat-checkbox class="rounded-xl" (change)="onCheck($event, item)" [checked]="item.checked || false" *ngIf="showCheckboxes && !isPostingModule">
                    </mat-checkbox> -->

            <mat-checkbox
              class="rounded-xl small-checkbox"
              #checkBoxes
              (change)="onCheck($event, item)"
              [checked]="item.checked || false"
              *ngIf="showCheckboxes"
              [disabled]="item['disableCheckbox']"
              [ngClass]="item['disableCheckbox'] ? 'greyCheck' : ''"
            >
            </mat-checkbox>
            <!-- <mat-checkbox class="rounded-xl" #checkBoxes (change)="onCheck($event, item)" [checked]="item.checked || false" *ngIf="showCheckboxes && isPostingModule" [disabled]="
              (activeState !== 'pending' &&
              item['reversed']) ||
              item['transaction_type']?.toLowerCase() === 'reversal' ||
              (!item['reversed'] && item['reversal_transaction_id']) ||
              (item['transaction_type']?.toLowerCase() !== 'manual_entry' && !item['reversed'] && item['reversal_transaction_id']) ||
              (item['transaction_type']?.toLowerCase() !== 'manual_entry' && !item['reversed'])
            " [ngClass]="[
              (activeState !== 'pending' && item['reversed']) ||
              item['transaction_type']?.toLowerCase() === 'reversal' ||
              (!item['reversed'] && item['reversal_transaction_id']) ||
              (item['transaction_type']?.toLowerCase() !== 'manual_entry' &&
                !item['reversed'] &&
                item['reversal_transaction_id']) ||
              (item['transaction_type']?.toLowerCase() !== 'manual_entry' &&
                !item['reversed'])
                ? 'greyCheck'
                : ''
            ]">
                    </mat-checkbox> -->
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <span>
              {{ column.footer }}
            </span>
          </td>
        </ng-container>
      </ng-container>

      <!-- spacer: absorbs remaining table width with no visible content -->
      <ng-container *ngIf="column.type === 'spacer'">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item" (click)="triggerRowClick(item)"></td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- if reversal -->
      <ng-container *ngIf="column.type === 'reversal'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          [ngClass]="{ 'text-red-500': item['reversed'] }"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span class="" [matTooltip]="item[column.value]">
            {{
              item[column.value].replace("_", " ")
                | truncate: column.maxLen
                | titlecase
            }}
            <span class="text-danger" *ngIf="item[column.isReversed] === true"
              >(reversed)</span
            >
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <!-- if text -->
      <ng-container *ngIf="column.type === 'text'">
        <th
          [class.floatRight]="column.align === 'right'"
          [class.col-center]="column.align === 'center'"
          [style.text-align]="column.align === 'right' ? 'right' : null"
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
          <span
            class="ml-[5px]"
            *ngIf="column.toolIcon"
            [matTooltip]="column.tooltip || ''"
            data-toggle="tooltip"
            data-placement="left"
          >
            <mat-icon
              class="text-secondary !w-[18px] !h-[18px]"
              svgIcon="info"
            ></mat-icon>
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          [class.text-right]="column.align === 'right'"
          [class.text-center]="column.align === 'center'"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span
            [ngClass]="getTextColumnClass(item, column)"
            [matTooltip]="item[column.value]"
          >
            {{
              item[column.value]?.toString() || "-"
                | underScoreToSpace
                | titlecase
                | truncate: column.maxLen
            }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <!-- if uppercase text (no titlecase transform) -->
      <ng-container *ngIf="column.type === 'uppercase'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>{{ column.name }}</span>
        </th>
        <td
          mat-cell
          class="text-sm"
          [class.text-right]="column.align === 'right'"
          [class.text-center]="column.align === 'center'"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span class="uppercase">
            {{ item[column.value] || '-' }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <!-- if btn -->
      <ng-container *ngIf="column.type === 'btn'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span
            [ngClass]="{ 'text-red-500': item['reversed'] }"
            [matTooltip]=""
          >
            <app-button-img-viewer
              [value]="item[column.value]"
            ></app-button-img-viewer>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>

      <ng-container *ngIf="column.type === 'customStatus'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>{{ column.name }}</span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span
            class="px-3 py-1 rounded-sm text-sm font-medium inline-block"
            [ngClass]="getStatusColumnClass(item, column)"
            [matTooltip]="item[column.value]"
          >
            {{ item[column.value] | titlecase }}
          </span>
          <button
            *ngIf="canShowRetry(item, column)"
            type="button"
            class="ml-2 align-middle inline-flex items-center border-none bg-transparent p-0"
            [class.cursor-pointer]="canRetry(item, column)"
            [class.cursor-not-allowed]="!canRetry(item, column)"
            [disabled]="!canRetry(item, column)"
            [matTooltip]="canRetry(item, column) ? retryEnabledTooltip : retryDisabledTooltip"
            (click)="onRetryClick(item, column, $event)"
          >
            <mat-icon
              svgIcon="retry"
              class="!w-[16px] !h-[16px] !text-[16px] leading-none"
              [ngClass]="canRetry(item, column) ? 'text-primary' : 'text-gray-400 opacity-50'"
            ></mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- if action btn -->
      <ng-container *ngIf="column.type === 'actionBtn'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
        >
          <div *ngIf="column.key === 'actions'; else singleRowAction" class="table-row-actions">
            <button
              type="button"
              class="table-row-action"
              (click)="onActionButtonClick($event, item, 'edit')"
              [attr.aria-label]="getActionAriaLabel('edit')"
            >
              <img src="assets/icons/edit-pen-icon.svg" alt="" />
            </button>
            <button
              type="button"
              class="table-row-action table-row-action-delete"
              (click)="onActionButtonClick($event, item, 'delete')"
              [attr.aria-label]="getActionAriaLabel('delete')"
            >
              <img src="assets/icons/delete-bin.svg" alt="" />
            </button>
          </div>
          <ng-template #singleRowAction>
          <button
            type="button"
            class="table-row-action"
            [class.table-row-action-delete]="column.key === 'delete'"
            (click)="onActionButtonClick($event, item, column.value)"
            [attr.aria-label]="getActionAriaLabel(column.key)"
          >
            <img
              *ngIf="column.key === 'edit' || column.key === 'delete'; else actionText"
              [src]="column.key === 'edit' ? 'assets/icons/edit-pen-icon.svg' : 'assets/icons/delete-bin.svg'"
              alt=""
            />
            <ng-template #actionText>{{ column.key }}</ng-template>
          </button>
          </ng-template>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <!-- if checkIcon -->
      <ng-container *ngIf="column.type === 'checkIcon'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm text-center"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <mat-icon
            *ngIf="item[column.value]"
            class="text-success !w-[15px] !h-[15px]"
            svgIcon="check"
          ></mat-icon>
          <mat-icon
            *ngIf="!item[column.value]"
            class="text-error !w-[15px] !h-[15px]"
            svgIcon="cross"
          ></mat-icon>
        </td>
        <td class="text-center" mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <!-- if email -->
      <ng-container *ngIf="column.type === 'email'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          [ngClass]="{ 'text-red-500': item['reversed'] }"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span class="" [matTooltip]="item[column.value]">
            {{ item[column.value] | truncate: column.maxLen }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <!-- if boolean -->
      <ng-container *ngIf="column.type === 'boolean'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          [ngClass]="column.class"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span
            [ngClass]="{ 'text-red-500': item['reversed'] }"
            [matTooltip]="item[column.value]"
          >
            <ng-container
              *ngIf="column.value === 'reversed'; else defaultBoolean"
            >
              <span>
                {{
                  item[column.value]
                    | booleanReversedValues: item["reversal_transaction_id"]
                }}</span
              >
            </ng-container>

            <ng-template #defaultBoolean>
              {{ item[column.value] | booleanValues }}
            </ng-template>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <!-- if object access key in objectVal -->
      <ng-container *ngIf="column.type === 'object'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm text-left"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-red-500': item['reversed'] }">
            {{ item[column.value] | findValInObject: column.objectVal }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <!-- if number, use commas -->
      <ng-container *ngIf="column.type === 'number'">
        <th
          class="floatRight"
          [class.col-center]="column.align === 'center'"
          style="text-align: right"
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
          <span
            class="ml-[5px]"
            *ngIf="column.toolIcon"
            [matTooltip]="column.tooltip || ''"
            data-toggle="tooltip"
            data-placement="left"
          >
            <mat-icon
              class="text-secondary !w-[18px] !h-[18px]"
              svgIcon="info"
            ></mat-icon>
          </span>
        </th>
        <!-- A column's own class wins; otherwise its align (right or centre, so
             amounts line up their digits), otherwise left. -->
        <td
          mat-cell
          class="text-sm"
          [ngClass]="column.class || (column.align ? '' : 'text-left')"
          [class.text-right]="!column.class && column.align === 'right'"
          [class.text-center]="!column.class && column.align === 'center'"
          [class.text-left]="!column.class && column.align === 'left'"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span class="" [ngClass]="{ 'text-red-500': item['reversed'] }">
            {{ item[column.value] | formatNumber: column.decimals ?? 2 }}
          </span>
        </td>
        <td
          style="text-align: right"
          class="floatRight"
          mat-footer-cell
          *matFooterCellDef
        >
          <span>
            {{ column.footer | formatNumber: column.decimals ?? 2 }}
          </span>
        </td>
      </ng-container>

      <!-- if numberWithDecimal, use commas and two place decimal -->
      <ng-container *ngIf="column.type === 'numberWithDecimal'">
        <th
          style="text-align: right"
          class="floatRight"
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
          <span
            class="ml-[5px]"
            *ngIf="column.toolIcon"
            [matTooltip]="column.tooltip || ''"
            data-toggle="tooltip"
            data-placement="left"
          >
            <mat-icon
              class="text-secondary !w-[18px] !h-[18px]"
              svgIcon="info"
            ></mat-icon>
          </span>
        </th>
        <td
          mat-cell
          class="text-sm text-right"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span
            class=""
            [ngClass]="{ 'text-red-500': item['reversed'] }"
            [ngClass]="item?.class"
          >
            {{ item[column.value] | formatNumber }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef style="text-align: right">
          <span class="">
            {{ column.footer | formatNumber }}
          </span>
        </td>
      </ng-container>
      <!-- if id -->
      <ng-container *ngIf="column.type === 'id'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm text-right"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-red-500': item['reversed'] }">
            {{ item[column.value] }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>

      <!-- if currency or percentile -->
      <ng-container *ngIf="column.type === 'currency_percentile'">
        <th
          class="floatRight"
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
          <span
            class="ml-[5px]"
            *ngIf="column.toolIcon"
            [matTooltip]="column.tooltip || ''"
            data-toggle="tooltip"
            data-placement="left"
          >
            <mat-icon
              class="text-secondary !w-[18px] !h-[18px]"
              svgIcon="info"
            ></mat-icon>
          </span>
        </th>

        <td
          mat-cell
          class="text-sm !text-right"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <ng-container *ngIf="item?.chargeType; else formatCurrency">
            <span *ngIf="item?.chargeType === 'FLAT'; else percentFormat">
              {{ item[column.value] | currency : item['currency'] }}
            </span>
            <ng-template #percentFormat>
              {{ item[column.value] | wz_percentage_format_2 }}
            </ng-template>
          </ng-container>

          <ng-template #formatCurrency>
            {{ item[column.value] | currency : item['currency'] }}
          </ng-template>
        </td>
      </ng-container>
      <!-- if currency format with symbol -->
      <ng-container *ngIf="column.type === 'currency'">
        <th
          class="!text-right"
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
          <span
            class="ml-[5px]"
            *ngIf="column.toolIcon"
            [matTooltip]="column.tooltip || ''"
            data-toggle="tooltip"
            data-placement="left"
          >
            <mat-icon
              class="text-secondary !w-[18px] !h-[18px]"
              svgIcon="info"
            ></mat-icon>
          </span>
        </th>
        <td
          mat-cell
          class="text-sm !text-right"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-red-500': item['reversed'] }">
            <ng-container *ngIf="item?.chargeType; else formatCurrency">
              <span *ngIf="item?.chargeType === 'FLAT'; else percentFormat">
                {{ item[column.value] | currency : (column.currencyCode || (column.currencyCodeField ? item[column.currencyCodeField] : undefined)) }}
              </span>
              <ng-template #percentFormat>
                {{ item[column.value] | wz_percentage_format_2 }}
              </ng-template>
            </ng-container>

            <ng-template #formatCurrency>
              {{ item[column.value] | currency : (column.currencyCode || (column.currencyCodeField ? item[column.currencyCodeField] : undefined)) }}
            </ng-template>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef style="text-align: right">
          <span>
            {{ column.footer | wz_currency_non_symbol }}
          </span>
        </td>
      </ng-container>
      <ng-container *ngIf="column.type === 'percentile'">
        <th
          class="floatRight"
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm text-left"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-red-500': item['reversed'] }">
            {{ item[column.value] | wz_percentage_format_2 }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <ng-container *ngIf="column.type === 'date'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
          <span
            class="ml-[5px]"
            *ngIf="column.toolIcon"
            [matTooltip]="column.tooltip || ''"
            data-toggle="tooltip"
            data-placement="left"
          >
            <mat-icon
              class="text-secondary !w-[18px] !h-[18px]"
              svgIcon="info"
            ></mat-icon>
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-red-500': item['reversed'] }">
            {{ item[column.value] | tenantDate }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <ng-container *ngIf="column.type === 'dateTime'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-red-500': item['reversed'] }">
            {{ item[column.value] | tenantDate: true }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <ng-container *ngIf="column.type === 'dateTimeMeridian'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-red-500': item['reversed'] }">
            {{ item[column.value] | date: "dd-MM-yyyy hh:mm a" }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <ng-container *ngIf="column.type === 'customDateSelect'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span class="bg-red-500">
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <mat-form-field
            class="w-full"
            [ngClass]="{ 'text-red-500': item['reversed'] }"
            appearance="outline"
          >
            <input
              readonly
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="picker"
              placeholder="Choose a date"
              [(ngModel)]="item[column.value]"
            />
            <mat-datepicker-toggle matSuffix [for]="picker">
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <ng-container *ngIf="column.type === 'phone'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-red-500': item['reversed'] }">
            {{ item[column.value] | wz_phone_number }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>
      <ng-container *ngIf="column.type === 'multiValue'">
        <th
          mat-sort-header
          [disabled]="!column.onSort"
          mat-header-cell
          *matHeaderCellDef
        >
          <span>
            {{ column.name }}
          </span>
        </th>
        <td
          mat-cell
          class="text-sm text-left"
          *matCellDef="let item"
          (click)="triggerRowClick(item)"
        >
          <span [ngClass]="{ 'text-red-500': item['reversed'] }">
            {{ column.values | mergeMultiValues: item | titlecase }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span>
            {{ column.footer }}
          </span>
        </td>
      </ng-container>

      <!-- <ng-container *ngIf="column.type === 'enum'">
          <th mat-sort-header [disabled]="!column.onSort" mat-header-cell *matHeaderCellDef>
              <span>
          {{ column.name }}
        </span>
          </th>
          <td mat-cell class="text-sm" *matCellDef="let item" (click)="triggerRowClick(item)">
              <span [ngClass]="{ 'text-red-500': item['reversed'] }">
          {{ item[column.value]?.replace('_', ' ') }}
        </span>
          </td>
          <td mat-footer-cell *matFooterCellDef>
              <span>
          {{ column.footer }}
        </span>
          </td>
      </ng-container> -->

      <!-- if more (...) -->
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <ng-container *ngIf="!usePermission">
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </ng-container>
    <ng-container *ngIf="usePermission">
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.hidden]="!hasPermission(row.perms)"
      ></tr>
    </ng-container>
    <ng-container *ngIf="showFooter">
      <tr
        mat-footer-row
        *matFooterRowDef="displayedColumns; sticky: true"
        class="font-semibold"
      ></tr>
    </ng-container>
  </table>
</div>

<app-pagination-ui
  (togglePageControlEmit)="onPageCtrlToggle($event)"
  (pageSizeToggleEmit)="onPageSizeToggle($event)"
  [showPagination]="showPagination"
  [pageProp]="pageProp"
></app-pagination-ui>
